import React, { PureComponent } from "react";
import PopperTooltip from "tooltip.js";

const isTouch = "ontouchstart" in document.documentElement;

export default class Tooltip extends PureComponent {
  _ref = el => {
    if (el && !this.tooltip) {
      this.tooltip = new PopperTooltip(el, {
        title: this.props.description,
        trigger: isTouch ? "click" : "hover focus",
        closeOnClickOutside: true
      });
    }
  };

  componentWillUnmount() {
    if (this.tooltip) {
      this.tooltip.dispose();
    }
  }

  render() {
    const { className, name } = this.props;

    return (
      <span ref={this._ref} className={className}>
        {name}
      </span>
    );
  }
}
